import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'neoris-dialog-form-confirm',
  templateUrl: './dialog-form-confirm.component.html',
  styleUrls: ['./dialog-form-confirm.component.css']
  
})
export class DialogFormConfirmComponent  {
  
  constructor(public dialogRef: MatDialogRef<DialogFormConfirmComponent>
    ,private route:Router) { 

    }

  


  back(){
    this.route.navigate(['/health-safety-control-tower-dashboard'])

    this.dialogRef.close()
  }

  close(){
    this.dialogRef.close()
  }

}
